import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { AppService } from '../../app.service';
import { Article } from '../../models/article';
import { RouterModule } from '@angular/router';
import { DateFormatPipe } from '../../pipes/date-format.pipe';
import { StripHtmlPipe } from '../../pipes/strip-html.pipe';

@Component({
  selector: 'app-press',
  standalone: true,
  providers: [AppService],
  imports: [
    CommonModule,
    RouterModule,
    DateFormatPipe,
    StripHtmlPipe
  ],
  template: `    
    <div class="main-title">
        <div class="headings">
            <h1>Press Releases</h1>
        </div>
    </div>

    <div class="container news-content">
        @if (isLoading) {
            <div class="text-center py-5">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2">Loading articles...</p>
            </div>
        } @else if (articles.length > 0) {
            <div class="row p-5">
                @for (article of articles; track article.id) {
                    <div class="col-md-4 mb-4">
                        <div class="card h-100">
                            @if (article.cover_image) {
                                <img [src]="'https://api.brandripplr.com/storage/v1/object/public/brandripplr/' + article.cover_image" class="card-img-top" [alt]="article.title">
                            }
                            <div class="card-body">
                                <!-- published_at -->
                                <p class="card-text text-muted">
                                    <i class="bi bi-calendar-event me-1"></i>
                                    {{ article.published_at | dateFormat:'mediumDate' }}
                                </p>
                                <h2 class="card-title"><a [routerLink]="'/news/' + article.slug" class="text-decoration-none ">{{ article.title }}</a></h2>
                                @if (article.content) {
                                    <p class="card-text">{{ article.content | stripHtml:20 }}</p>
                                }
                                <a [routerLink]="'/news/' + article.slug" class="btn btn-primary">Read More</a>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </div>
`,
  styleUrls: ['./press.component.scss']
})
export class PressComponent implements OnInit {
  articles: Article[] = [];
  isLoading = true;
  
  constructor(
    private titleService: Title, 
    private metaService: Meta,
    private appService: AppService,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
    this.titleService.setTitle("Press Releases | Brandripplr");
    this.metaService.updateTag({ 
      name: 'description', 
      content: '' 
    });
  }
  
  forceUpdate() {
    this.cdr.detectChanges();
  }

  async ngOnInit() {
    try {
      console.log('Fetching articles...');
      const articles = await this.appService.getArticles('press-release');
      console.log('Articles received:', articles);
      
      // Run inside NgZone to ensure change detection works
      this.ngZone.run(() => {
        this.articles = articles || [];
        console.log('Articles after assignment:', this.articles);
        this.isLoading = false;
        this.cdr.markForCheck();
      });
    } catch (error) {
      console.error('Error loading articles:', error);
      this.ngZone.run(() => {
        this.articles = [];
        this.isLoading = false;
        this.cdr.markForCheck();
      });
    }
  }

}
